import React, { useEffect, useRef } from 'react'
import { IDimensionsCol, IDimensionsRow } from '../Reports/DashboardVuParams';
import { useDispatch } from 'react-redux';
import { setVuObjectInfoStore } from '../../Redux/VisualUnits/visualUnitStateSlice';
import { FoundationsConstants } from '../../FoundationsConstants';
import {VisualUnitApiDTO_EditSaveVisualUnit} from '../../Interfaces/APIContracts/VisualUnitApiDTO_EditSaveVisualUnit'
import { useApplyHighlight } from '../../GenericComponents/useApplyHighlight';

interface IDimensionsProps {
    availRows: any[],
    availCols: any[],
    setAvailRows: React.Dispatch<React.SetStateAction<any[]>>,
    setAvailCols: React.Dispatch<React.SetStateAction<any[]>>,
    vuId: number,
    // showDimensionListDialog: (vuId: number, vuIndex: number, isRow: boolean, isAdd: boolean, actionType: string) => void,
    showDimensionListDialog: Function,
    objDataFromStore: string,
    getVisualUnitParamsIndex: Function,
    setVuObj: React.Dispatch<React.SetStateAction<string>>,
    displayFieldErrors: (addedCount: number, callFrom: "add" | "save", action: "measure" | "dimensionRow" | "dimensionColumn") => void,
    setShowSaveandSaveAs: React.Dispatch<React.SetStateAction<boolean>>
}
const DimensionFrame = (props: IDimensionsProps) => {
    const dispatch = useDispatch()
    
    const {availRows, availCols, setAvailRows, setAvailCols, vuId, showDimensionListDialog, objDataFromStore, getVisualUnitParamsIndex, setVuObj, displayFieldErrors, setShowSaveandSaveAs} = props
    const handleDragStart = (event: React.DragEvent<HTMLLIElement>, index: number, sourceList: string) => {
        event.dataTransfer.setData('text/plain', JSON.stringify({
            sourceList,
            index
        }));
    };
const {applyHighlight, highlightClass } = useApplyHighlight(FoundationsConstants.APPLY_HIGHLIGHT_DURATION);

    const handleDragOver = (event: React.DragEvent<HTMLLIElement>) => {
        event.preventDefault();
    };

    const handleDrop = (targetIndex: number, event: React.DragEvent<HTMLLIElement> | React.DragEvent<HTMLOListElement>, targetList: string) => {
        event.preventDefault();
        event.stopPropagation(); //to prevent double firing on LI and OL
        let _vuIndex = getVisualUnitParamsIndex(vuId, JSON.parse(objDataFromStore))
        let indexedVuObj: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(objDataFromStore)]
        
        const draggedData = JSON.parse(event.dataTransfer.getData('text/plain'));
        const { sourceList, index: sourceIndex } = draggedData;
        if (sourceList === targetList) {
            // Internal move
            if (targetList === 'availRows') {
                const updated = [...availRows];
                const [movedItem] = updated.splice(sourceIndex, 1);

                let storeObject = [...indexedVuObj[_vuIndex].dimensionRow]
                const [movedPayloadItem] = storeObject.splice(sourceIndex, 1)

                storeObject.splice(targetIndex, 0, movedPayloadItem)
                indexedVuObj[_vuIndex].dimensionRow = storeObject
                setVuObj(JSON.stringify(indexedVuObj))
                dispatch(setVuObjectInfoStore({ data: indexedVuObj }))

                updated.splice(targetIndex, 0, movedItem);
                setAvailRows(updated);
                if (updated.length <= FoundationsConstants.ALLOWED_DIMENSIONS) {
                    displayFieldErrors(updated.length, "save", "dimensionRow")
                }
            } else if (targetList === 'availCols') {
                const updated = [...availCols];
                const [movedItem] = updated.splice(sourceIndex, 1);
                updated.splice(targetIndex, 0, movedItem);
                setAvailCols(updated);

                let storeObject = [...indexedVuObj[_vuIndex].dimensionCol]
                const [movedPayloadItem] = storeObject.splice(sourceIndex, 1)

                storeObject.splice(targetIndex, 0, movedPayloadItem)
                indexedVuObj[_vuIndex].dimensionCol = storeObject
                setVuObj(JSON.stringify(indexedVuObj))
                dispatch(setVuObjectInfoStore({ data: indexedVuObj }))
                if (updated.length <= FoundationsConstants.ALLOWED_DIMENSIONS) {
                    displayFieldErrors(updated.length, "save", "dimensionColumn")
                }
            }
        } else {
            // Cross move
            if (sourceList === 'availRows' && targetList === 'availCols') {

                let storeRowObject = [...indexedVuObj[_vuIndex].dimensionRow]
                const updatedSource = [...availRows];
                const [movedItem] = updatedSource.splice(sourceIndex, 1);

                const [movedPayloadItem] = storeRowObject.splice(sourceIndex, 1)

                if (availCols.length >= FoundationsConstants.ALLOWED_DIMENSIONS) {
                    displayFieldErrors(availCols.length, "add", "dimensionColumn")
                    return;
                }
                const updatedTarget = [...availCols];

                const updatedStoreTarget = [...indexedVuObj[_vuIndex].dimensionCol]
                updatedTarget.splice(targetIndex, 0, movedItem);

                updatedStoreTarget.splice(targetIndex, 0, movedPayloadItem)
                indexedVuObj[_vuIndex].dimensionRow = storeRowObject
                indexedVuObj[_vuIndex].dimensionCol = updatedStoreTarget

                setVuObj(JSON.stringify(indexedVuObj))
                dispatch(setVuObjectInfoStore({ data: indexedVuObj }))
                
                setAvailRows(updatedSource);
                setAvailCols(updatedTarget);
                if(updatedTarget.length === FoundationsConstants.ALLOWED_DIMENSIONS){
                    displayFieldErrors(updatedTarget.length, "add", "dimensionColumn")
                }else{
                    displayFieldErrors(updatedTarget.length, "save", "dimensionColumn")
                }
            } else if (sourceList === 'availCols' && targetList === 'availRows') {

                const updatedSource = [...availCols];
                const [movedItem] = updatedSource.splice(sourceIndex, 1);
                if (availRows.length >= FoundationsConstants.ALLOWED_DIMENSIONS) {
                    displayFieldErrors(availRows.length, "add", "dimensionRow")
                    return;
                }
                const updatedTarget = [...availRows];
                updatedTarget.splice(targetIndex, 0, movedItem);

                //For Store
                let storeColObject = [...indexedVuObj[_vuIndex].dimensionCol]
                const [movedPayloadItem] = storeColObject.splice(sourceIndex, 1)

                const updatedStoreTarget = [...indexedVuObj[_vuIndex].dimensionRow]
                updatedStoreTarget.splice(targetIndex, 0, movedPayloadItem)

                indexedVuObj[_vuIndex].dimensionCol = storeColObject
                indexedVuObj[_vuIndex].dimensionRow = updatedStoreTarget

                setVuObj(JSON.stringify(indexedVuObj))
                dispatch(setVuObjectInfoStore({ data: indexedVuObj }))

                setAvailCols(updatedSource);
                setAvailRows(updatedTarget);
                if(updatedTarget.length === FoundationsConstants.ALLOWED_DIMENSIONS){
                    displayFieldErrors(updatedTarget.length, "add", "dimensionRow")
                }else{
                    displayFieldErrors(updatedTarget.length, "save", "dimensionRow")
                }
            }
        }
    };
const deleteDimensionRow = (event: any, dimensionIndex: number) => {
        event.stopPropagation()
        let _vuIndex = getVisualUnitParamsIndex(vuId, JSON.parse(objDataFromStore))

        let indexedVuObj: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(objDataFromStore)]
        let availDimensionsRow = [...availRows]
        availDimensionsRow = availDimensionsRow.filter((_, index) => index !== dimensionIndex)

        let addedDimRowPayload = indexedVuObj[_vuIndex].dimensionRow
        addedDimRowPayload = addedDimRowPayload.filter(
            (_: any, index: number) => index !== dimensionIndex
        )

        indexedVuObj[_vuIndex].dimensionRow = addedDimRowPayload

        setAvailRows(availDimensionsRow)
        setVuObj(JSON.stringify(indexedVuObj))
        dispatch(setVuObjectInfoStore({ data: indexedVuObj }))
        displayFieldErrors(addedDimRowPayload.length, "add", "dimensionRow")
        setShowSaveandSaveAs(false)
    }

    const deleteDimensionCol = (Event: any, dimensionIndex: number) => {
        Event.stopPropagation()
        let indexedVuObj: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(objDataFromStore)]
        let availDimensionsCol = [...availCols]
        let _vuIndex = getVisualUnitParamsIndex(vuId, JSON.parse(objDataFromStore))

        availDimensionsCol = availDimensionsCol.filter((_, index) => index !== dimensionIndex)

        let addedDimColPayload = indexedVuObj[_vuIndex].dimensionCol
        addedDimColPayload = addedDimColPayload.filter(
            (_: any, index: number) => index !== dimensionIndex
        )

        indexedVuObj[_vuIndex].dimensionCol = addedDimColPayload

        setAvailCols(availDimensionsCol)
        setVuObj(JSON.stringify(indexedVuObj))
        dispatch(setVuObjectInfoStore({ data: indexedVuObj }))
        displayFieldErrors(addedDimColPayload.length, "add", "dimensionRow")
        setShowSaveandSaveAs(false)
    }
const previousColLengthRef = useRef(availCols.length);
const previousRowLengthRef = useRef(availRows.length);

    useEffect(() => {
            const prevLen = previousColLengthRef.current;
            const newLen = availCols.length;
            if (newLen > prevLen) {
                // New measure added at the beginning? (or use newLen - 1)
                const newIndex = prevLen;
                const id = `add_dimension_col_${newIndex}`;
    
                setTimeout(() => {
                    applyHighlight(id, 'applyHighLight', { autoHide: false });
                }, 0);
            }
            previousColLengthRef.current = newLen;
        }, [availCols.length]);
        
    useEffect(() => {
            const prevLen = previousRowLengthRef.current;
            const newLen = availRows.length;
            if (newLen > prevLen) {
                // New measure added at the beginning? (or use newLen - 1)
                const newIndex = prevLen;
                const id = `add_dimension_row_${newIndex}`;
    
                setTimeout(() => {
                    applyHighlight(id, 'applyHighLight', { autoHide: false });
                }, 0);
            }
            previousRowLengthRef.current = newLen;
        }, [availRows.length]);
        
    return (
        <td className="td-dimensions">
            <div className="dimension-rows">
                <div className="header float-left">Organize Rows</div>
                <div className="action float-right">
                    <a
                        href="javascript:void(0);"
                        onClick={() => {
                            showDimensionListDialog(
                                vuId,
                                getVisualUnitParamsIndex(
                                    vuId,
                                    JSON.parse(objDataFromStore)
                                ),
                                false,
                                true,
                                'addrow'
                            )
                        }}
                        title="Add a new dimension (row)"
                    >
                        Add
                    </a>
                </div>
                <div className="clear-both"></div>
                {/* <DimensionRowFrame
                    showUpdateDimensionListDialog={
                        showDimensionListDialog
                    }
                    objDataFromStore={vuObj}
                    availRows={availRows}
                    setAvailRows={setAvailRows}
                    setVuObj={setVuObj}
                    vuId={vuId}
                /> */}
                {/* TODO: This is DimensionRow frame content */}
                <ol
                    onDragOver={(event) => {
                        event.preventDefault(); // Allow dropping
                        event.dataTransfer.dropEffect = 'move'; // Visual feedback
                    }}
                    onDrop={(event) => handleDrop(availRows.length, event, 'availRows')}

                    id={`vu_params_dimension_rows_list_${vuId}`}
                    className="connected-sortable ui-sortable"
                    data-dimtype="rowslist"
                >
                    {availRows &&
                        availRows.map((itr: IDimensionsRow, index: number) => {
                            return (
                                <li key={`dimensionRow_item_${index}`}
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, index, "availRows")}
                                    onDragOver={handleDragOver}
                                    onDrop={(e) => handleDrop(index, e, "availRows")}
                                    id={`vu_params_dimension_row_${vuId}_${index}`}
                                    className={`vu-button ui-state-default ui-corner-all vu-object pos-relative clear-both dimension-col 
                                        ui-sortable-handle
                                        ${highlightClass[`add_dimension_row_${index}`] ?? ""}
                                        `}
                                    onClick={() =>
                                        showDimensionListDialog(
                                            vuId,
                                            itr.vuIndex,
                                            undefined,
                                            true,
                                            'updateRow',
                                            itr,
                                            index
                                        )
                                    }
                                >
                                    <a
                                        id={`vu_params_dimension_row_delete_${vuId}_${index}`}
                                        className="vu-object-delete-container"
                                        href="javascript:void(0);"
                                        onClick={(event) => deleteDimensionRow(event, index)}
                                    >
                                        <span className="vu-object-delete"></span>
                                    </a>
                                    <div className="dimension-info">{itr.dimensionName}</div>
                                    {/* <div className="bin-info">Trend Year-Month</div> */}
                                    <div className="bin-info">{itr.binName}</div>
                                </li>
                            )
                        })}
                </ol>
            </div>
            <div className="dimension-cols clear-both">
                <div className="header float-left">
                    Organize Columns
                </div>
                <div className="action float-right">
                    <a
                        href="javascript:void(0);"
                        onClick={() => {
                            showDimensionListDialog(
                                vuId,
                                getVisualUnitParamsIndex(
                                    vuId,
                                    JSON.parse(objDataFromStore)
                                ),
                                undefined,
                                true,
                                'addcolumn'
                            )
                        }}
                        title="Add a new dimension (column)"
                    >
                        Add
                    </a>
                </div>
                <div className="clear-both"></div>
                {/* TODO: This is dimension col frame */}
                <ol
                onDragOver={(event) => {
                    event.preventDefault(); // Allow dropping
                    event.dataTransfer.dropEffect = 'move'; // Visual feedback
                }}
                onDrop={(event) => handleDrop(availCols.length, event, 'availCols')}
                    id={`vu_params_dimension_cols_list_${vuId}`}
                    className="connected-sortable ui-sortable"
                    data-dimtype="colslist"
                >
                    {availCols &&
                        availCols.map((itr: IDimensionsCol, index: number) => {
                            return (
                                <li key={`dimensioncol_item_${index}`}
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, index, "availCols")}
                                    onDragOver={handleDragOver}
                                    onDrop={(e) => handleDrop(index, e, "availCols")}
                                    id={`vu_params_dimension_col_${vuId}_${index}`}
                                    className={`u-button ui-state-default ui-corner-all vu-object pos-relative clear-both dimension-col 
                                        ui-sortable-handle
                                        ${highlightClass[`add_dimension_col_${index}`] ?? ""}
                                        `}
                                    onClick={() =>
                                        showDimensionListDialog(
                                            vuId,
                                            itr.vuIndex,
                                            undefined,
                                            true,
                                            'updateColumn',
                                            itr,
                                            index
                                        )
                                    }
                                >
                                    <a
                                        id={`vu_params_dimension_col_delete_${vuId}_${index}`}
                                        className="vu-object-delete-container"
                                        href="javascript:void(0);"
                                        onClick={(event) => deleteDimensionCol(event, index)}
                                    >
                                        <span className="vu-object-delete"></span>
                                    </a>
                                    <div className="dimension-info">{itr.dimensionName}</div>
                                    {/* <div className="bin-info">Trend Year-Month</div> */}
                                    <div className="bin-info">{itr.binName}</div>
                                </li>
                            )
                        })}
                </ol>
            </div>
        </td>
    )
}

export default DimensionFrame